import { v4 } from 'uuid';
import { ChatItemMessage, ChatItemType, ChatItemSourceType } from 'app/services/chatBot';

export const createUserMessage = (
  message: string,
  source: ChatItemSourceType = ChatItemSourceType.PATIENT
): ChatItemMessage =>
  ({
    type: ChatItemType.MESSAGE,
    message,
    visible: true,
    uuid: v4(),
    source,
    delay_duration: 0,
    aiResponse: false,
    userMessage: true,
  }) as ChatItemMessage;

export const createErrorMessage = (): ChatItemMessage =>
  ({
    type: ChatItemType.MESSAGE,
    message: 'Something went wrong. Please try again.',
    visible: true,
    uuid: v4(),
    source: ChatItemSourceType.BOT,
    delay_duration: 0,
    aiResponse: false,
    errorMessage: true,
  }) as ChatItemMessage;

export const createBotMessage = (message: string): ChatItemMessage =>
  ({
    type: ChatItemType.MESSAGE,
    message,
    visible: true,
    uuid: v4(),
    source: ChatItemSourceType.BOT,
    identity: 'Bot',
    delay_duration: 0,
    aiResponse: true,
  }) as ChatItemMessage;
